// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2nAyE","noInteraction":"EventWrapper_noInteraction__2VaWq"};